import { Cloudinary } from '@cloudinary/url-gen';

export const CLOUD_NAME = 'www-alexjcampbell-me';

export const cloudinary = new Cloudinary({
  cloud: {
    cloudName: CLOUD_NAME
  }
});

export interface CloudinaryResource {
  public_id: string;
}

export const getThumbnailUrl = (publicId: string): string => {
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/c_fill,w_150,h_150,f_auto/${publicId}`;
};

export const getFullSizeUrl = (publicId: string): string => {
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/c_limit,w_800,h_600,f_auto/${publicId}`;
};

export const fetchImagesByTag = async (tag: string, limit: number = 150): Promise<CloudinaryResource[]> => {
  try {
    const response = await fetch(`https://res.cloudinary.com/${CLOUD_NAME}/image/list/${tag}.json`);
    const data = await response.json();
    return data.resources.slice(0, limit).map((resource: any) => ({
      public_id: resource.public_id
    }));
  } catch (error) {
    console.error(`Error fetching ${tag} images:`, error);
    return [];
  }
};
